module.exports = __webpack_public_path__ + "static/media/logo_menu.ef45bf24.svg";